function updateCartWithAGift(cart) {
    let updates = {};
    if (!("GIFT_PROMO_4_VARIANT_ID" in window) || !("giftPromoProductIds" in window) || !("GIFT_PROMO_4_MIN_CART_TOTAL" in window)) {
        return;
    }

    let cart_has_gift = false;
    let cart_requires_gift = false;

    let GIFT_PROMO_4_MIN_CART_TOTAL = window.GIFT_PROMO_4_MIN_CART_TOTAL * 100;
    let GIFT_PROMO_4_VARIANT_ID = window.GIFT_PROMO_4_VARIANT_ID;
    updates[GIFT_PROMO_4_VARIANT_ID] = 0;
    let giftPromoProductIds = window.giftPromoProductIds;

    let GIFT_PROMO_4_VARIANT_AVAILABLE = "GIFT_PROMO_4_VARIANT_AVAILABLE" in window ? window.GIFT_PROMO_4_VARIANT_AVAILABLE : false;
    if (GIFT_PROMO_4_VARIANT_AVAILABLE) {
        for (let i = 0; i < cart.items.length; i++) {
            // noinspection JSUnresolvedVariable
            let cond1 = !giftPromoProductIds.length || giftPromoProductIds.indexOf(cart.items[i].product_id) !== -1;
            // noinspection JSUnresolvedVariable
            let cond2 = cart.total_price > 0 && cart.total_price >= GIFT_PROMO_4_MIN_CART_TOTAL;
            if (cond1 && cond2) {
                // updates[GIFT_PROMO_4_VARIANT_ID] += cart.items[i].quantity;
                cart_requires_gift = true;
            }
            if (cart.items[i].id.toString() === GIFT_PROMO_4_VARIANT_ID && cart.items[i].quantity === 1) {
                cart_has_gift = true;
            }
        }
    }
    if ((cart_requires_gift && cart_has_gift) || (!cart_requires_gift && !cart_has_gift)) {
        return;
    }
    let xhrBody = `updates[${GIFT_PROMO_4_VARIANT_ID}]=${cart_requires_gift && !cart_has_gift ? 1 : 0}`;
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/update.js", true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 400) { // success
            if (location.pathname === "/cart") {
                location.reload();
            }
        } else { // we reached our target server, but it returned an error
            console.error("Unexpected server error");
        }
    };
    xhr.onerror = function() { // There was a connection error of some sort
        console.error("Unexpected connection error");
    };
    xhr.send(xhrBody);
}

/*
 * Add/remove gift on cart page load.
 * This is necessary as cart or gift promo settings could have been updated.
 */
if ("cwCartJson" in window) {
    updateCartWithAGift(window.cwCartJson);
}
